export default {
  technicalIssueBlockTitle: {
    id: 'bo_sellers_customer_care_all_requests_technical_issue_block_title',
    defaultMessage:
      'Requests can’t currently be loaded due to a technical problem',
  },
  loadingScreenLabel: {
    id: 'bo_sellers_customer_care_all_requests_loading_label',
    defaultMessage: 'Let’s see what’s in store for today...',
  },
  requestsTotalCount: {
    id: 'bo_sellers_customer_care_all_requests_total_request_count',
    defaultMessage: '{count, plural, one {# request} other {# requests}}',
  },
  currentPage: {
    id: 'bo_sellers_customer_care_pagination_current_page_aria_label',
    defaultMessage: 'Page {page}',
  },
  nextPage: {
    id: 'bo_sellers_customer_care_pagination_next_page_aria_label',
    defaultMessage: 'Next page',
  },
  previousPage: {
    id: 'bo_sellers_customer_care_pagination_previous_page_aria_label',
    defaultMessage: 'Previous page',
  },
  paginationLabel: {
    id: 'bo_sellers_customer_care_pagination_aria_label',
    defaultMessage: 'Navigate to page {page}',
  },
  navigationLabel: {
    id: 'bo_sellers_customer_care_pagination_navigation_aria_label',
    defaultMessage: 'Paginate between results',
  },
  noRequestFoundLinkLabel: {
    id: 'bo_sellers_customer_care_all_requests_no_request_found_block_link_label',
    defaultMessage: 'Learn about the Orders page',
  },
  noRequestFoundDescription: {
    id: 'bo_sellers_customer_care_all_requests_no_request_found_block_description',
    defaultMessage:
      'Service requests last updated before September 2023 or more than 3 years old are found via the Orders page.',
  },
}
